module["exports"] = [
  "Հյուսիսային",
  "Արևելյան",
  "Հարավային",
  "Արևմտյան",
  "Հյուսիսարևելյան",
  "Հյուսիսարևմտյան",
  "Հարավարևելյան",
  "Հարավարևմտյան"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/hy/address/direction.js
// module id = 3061
// module chunks = 1610